/** @format */

//import axios from 'axios';

export interface UninstantiatedUser {
  username: string;
  givenName: string;
  familyName: string;
  email: string;
}

export interface User extends UninstantiatedUser {
  id: string;
}

export interface RawUser {
  email: string;
  email_verified: boolean;
  family_name: string;
  given_name: string;
  locale?: string;
  name: string;
  preferred_username: string;
  realm_access?: {
    roles?: Array<string>;
  };
  resource_access?: {
    [clientName: string]: {
      roles?: Array<string>;
    };
  };
  sub?: string;
}

export default class UserModel implements User {
  email: string;
  givenName: string;
  id: string;
  familyName: string;
  username: string;

  constructor(email: string, givenName: string, id: string, familyName: string, username: string) {
    this.email = email;
    this.givenName = givenName;
    this.id = id;
    this.familyName = familyName;
    this.username = username;
  }

  /*  static async add(user: UninstantiatedUser): User {
    const u = await axios.post('', {})
    return new User();
  }*/
}
